<script>
import Template from '{Template}/Web/Pages/Market/Swap.template'
import AppLayout from '@/Layouts/AppLayout'
import TableFilter from "@/Mixins/Filter/TableFilter";
import IconFilter from "@/Components/Table/IconFilter";
import {mapGetters} from "vuex";
import {math_formatter, math_percentage} from "@/Functions/Math";

export default Template({
    components: {
        AppLayout,
        IconFilter
    },
    props: {
        currencies: Object,
        defaultBasePair: Number,
        defaultQuotePair: Number,
    },
    data() {
        return {
            reversed: false,
            processing: false,
            processing_balance: false,
            placingOrder: false,
            placedOrder: false,
            form: {
                quote_amount: '0.00',
                base_amount: null,
                market_id: null,
            },
            basePair: null,
            quotePair: null,
            exchangeRate: null,
            selectedMarket: null,
            selectedMarketBase: null,
            error: null,
            balance: '0.00',
            exchangeState: false,
	    
        }
    },
    computed: {
        baseMarkets: function () {
            return _.filter(this.currencies, (market) => {
                return market.id != this.quotePair;
            });
        },
        quoteMarkets: function () {
            return _.filter(this.currencies, (market) => {
                return market.id != this.basePair;
            });
        },
    },
    mounted() {

        if(this.defaultBasePair) {
            this.basePair = this.defaultBasePair;
        }

        if(this.defaultQuotePair) {
            this.quotePair = this.defaultQuotePair;
        }

    },
    methods: {
      
        setupInitialData() {
            this.loadExchangeRate();

            if(this.$store.getters.getUser) {
                this.getBalance();
            }
        },
        loadExchangeRate() {

            if(this.processing) return;

            this.error = null;
            this.processing = true;

            axios.get(this.route('market.exchange_rate'), {
                params: {
                    'base': this.basePair,
                    'quote': this.quotePair
                }
            }).then((res) => {

                this.processing = false;

                if(res.data && res.data.success) {
                    this.exchangeRate = res.data.rate;
                    this.selectedMarket = res.data.market;
                    this.selectedMarketBase= res.data.marketBase;
                    return;
                }

                this.error = res.data.message;
                this.exchangeRate = null;
                this.form.base_amount = null;
                this.form.quote_amount = '0.00';
                this.selectedMarket = false;
                this.selectedMarketBase = false;
                this.placedOrder = false;

            }).catch((error) => {
                this.processing = false;
            });
        },
        swapPair() {

            this.reversed = !this.reversed;

            let base = this.basePair;

            this.basePair = this.quotePair;
            this.quotePair = base;
        },
        getBalance() {

            if(this.processing_balance) return;

            this.processing_balance = true;

            axios.get(this.route('wallets.getBalance'), {
                params: {
                    'currency': this.basePair,
                }
            }).then((res) => {

                this.processing_balance = false;

                if(res.data && res.data.success) {
                    this.balance = res.data.balance;
                    return;
                }

                this.error = res.data.message;
            }).catch((error) => {
                this.processing_balance = false;
            });
        },
        injectBalance() {
            this.form.base_amount = this.balance;
        },
        submitExchange() {

            if(!this.$page.props.user) return;

            if(!this.selectedMarket || this.placingOrder) return;

            this.placingOrder = true;

            let action = this.selectedMarketBase == this.basePair ? 'sell' : 'buy';

            setTimeout(() => {

                this.exchangeState = 'searching';

                let data = {
                    market: this.selectedMarket,
                    type: 'market',
                    side: action,
                    quantity: this.form.base_amount,
                    swap: true,
                };

                if(action == "buy") {
                    data.quoteQuantity = this.form.base_amount;
                }

                axios.post(route('orders.store'), data).then((response) => {
                    this.placingOrder = false;
                    this.exchangeState = false;
                    this.placedOrder = true;
                }).catch(error => {
                    this.placingOrder = false;
                    this.exchangeState = false;
                    this.placedOrder = false;
                    _.each(error.response.data.errors, (field, key) => {
                        this.$toast.error(field[0]);
                    });
                });

            }, 1000);

        },
        handleInput ($event) {

            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

            if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || this.form.base_amount.toString().indexOf('.') != -1)) {
                $event.preventDefault();
            }

            let precision = 8;

            // restrict to 2 decimal places
            if(this.form.base_amount != null && this.form.base_amount.toString().indexOf(".")>-1 && (this.form.base_amount.toString().split('.')[1].length >= 99)){
                $event.preventDefault();
            }
        },
        clearInput ($event) {
            if(this.form.base_amount.toString().charAt(0) == '.') {
                this.form.base_amount = 0;
            }
        },
        startNewTrade() {
            this.placedOrder = false;
        }
    },
    watch: {
        'form.base_amount'(newVal){
            if (newVal.includes('.')) {
                this.form.base_amount = newVal.split('.')[0] + '.' + newVal.split('.')[1].slice(0, 8)
            }

            if(this.form.base_amount && !this.error && this.exchangeRate) {
                this.form.quote_amount = math_formatter(parseFloat(this.form.base_amount) * parseFloat(this.exchangeRate), 8);
            } else {
                this.form.quote_amount = '0.00';
            }
        },
    }

})
</script>









